import * as React from 'react'
import { Loader2 } from 'lucide-react'

import { cn } from '@/lib/utils'

/** Lightweight spinner — replaces MUI CircularProgress. `size` is px. */
function Spinner({ className, size = 18, ...props }) {
  return (
    <Loader2
      className={cn('animate-spin text-muted-foreground', className)}
      style={{ width: size, height: size }}
      {...props}
    />
  )
}

export { Spinner }
